var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-thumbnail-wrapper"},[_c('b-img',{class:`image-thumbnail ${_vm.extraClasses}`,attrs:{"src":_vm.imageSource,"id":_vm.id,"alt":_vm.altText}}),_c('b-popover',{attrs:{"target":_vm.id,"triggers":"hover","placement":_vm.placement}},[_c('img',{staticClass:"image-hover-preview",attrs:{"src":_vm.imageSource}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }